// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BulkFollowSuggestion-cls1__cc3bed9696b06dbd540a{/*!*/}.BulkFollowSuggestion-cls2___3c272c88b124bd91dcd{flex-grow:1;color:#223}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "BulkFollowSuggestion-cls1__cc3bed9696b06dbd540a",
	"cls2": "BulkFollowSuggestion-cls2___3c272c88b124bd91dcd BulkFollowSuggestion-cls1__cc3bed9696b06dbd540a"
};
export default ___CSS_LOADER_EXPORT___;
